import { Card, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import { number } from "prop-types";
import MaterialInput from "../components/MaterialInput";
import { date } from "yup";

const RecruitOnboardReport = () => {
  const nav = useNavigate();

  const department = {
    value: "",
  };
  const [textfeilds, settextfeild] = useState({
    position: "",
    date: "",
  });

  const handlefield = (e, type) => {
    if (type == "position")
      settextfeild((prevtext) => ({
        ...prevtext,
        position: e.target.value,
      }));
    else {
      settextfeild((prevtext) => ({
        ...prevtext,
        date: e.target.value,
      }));
    }
  };

  const handleclick = () => {
    nav("/onboarddashboard/sourceprofile");
  };
  const [Department, SetDepartment] = useState({ value: "" });

  const [Status, setStatus] = useState({ value: "" });

  const [jobid, setjobid] = useState({ value: "" });

  const [emptype, setemptype] = useState({ value: "" });

  const [role, setrole] = useState({ value: "" });

  const SalaryStructureListTable = {
    columns: [
      {
        field: "job id",
        headerName: "Job ID",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: " Name",
        headerName: "Name",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "Position",
        headerName: "Position",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "Status",
        headerName: "Status",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "Screening",
        headerName: "Screening",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Technical Interview",
        headerName: "Technical Interview",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Interview status",
        headerName: "Interview status",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Payslip Verification",
        headerName: "Payslip Verification",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Offer Letter",
        headerName: "Offer Letter",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "OnBoarding",
        headerName: "OnBoarding",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "Asset Request",
        headerName: "Asset Request",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Document Verification",
        headerName: "Document Verification",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Appointment Letter",
        headerName: "Appointment Letter",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "NDA",
        headerName: "NDA",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "HR Induction",
        headerName: "HR Induction",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "HR Induction",
        headerName: "HR Induction",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Technical Induction",
        headerName: "Technical Induction",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Team Intro",
        headerName: "Team Intro",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "Asset Handover",
        headerName: "Asset Handover",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "HRMS Aceess",
        headerName: "HRMS Aceess",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "HandOver to Manager",
        headerName: "HandOver to Manager",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
  };

  const handlechange = (event, setevent) => {

    if (setevent.name == "department") {
      const cloneddepartment = { ...Department };
      cloneddepartment.value = event;
      SetDepartment(cloneddepartment);
    } else if (setevent.name == "status") {
      const clonedstatus = { ...Status };
      clonedstatus.value = event;
      setStatus(clonedstatus);
    } else if (setevent.name == "role") {
      const clonedrole = { ...role };
      clonedrole.value = event;
      setrole(clonedrole);
    } else if (setevent.name == "role") {
      const clonedrole = { ...role };
      clonedrole.value = event;
      setrole(clonedrole);
    } else if (setevent.name == "Employe type") {
      const clonedemptype = { ...emptype };
      clonedemptype.value = event;
      setemptype(clonedemptype);
    } else {
      const clonedjobid = { ...jobid }; //Employe type
      clonedjobid.value = event;
      setjobid(clonedjobid);
    }
  };

  const departmentName = [
    {
      id: "HR",
      departmentName: "hr",
    },

    {
      id: "Dev",
      departmentName: "dev",
    },

    {
      id: "DEV",
      departmentName: "dev",
    },
  ];
  const jobids = [1, 2, 3];
  const status = ["completed", "pending"];

  const [Departmentnames, setnames] = useState({
    depatmentdate: departmentName,
  });
  const [jid, setjid] = useState({
    ids: jobids,
  });

  return (
   <DashboardLayout>
     <Card>
      <CardHeader
        title={
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              margin={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Recruitment and Onboard Report
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
              </Stack>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Jobid*
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="Jobid"
                  value={jobid.value}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlechange}
                  options={jid.ids.map((value, index) => {
                    return {
                      value: index,
                      label: value,
                    };
                  })}
                  error={false}
                  // success={true}
                  isClearable
                />
              </Stack>

              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Department*
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="department"
                  value={Department.value}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlechange}
                  options={Departmentnames.depatmentdate.map((value) => {
                    return {
                      value: value.id,
                      label: value.departmentName,
                    };
                  })}
                  error={false}
                  // success={true}
                  isClearable
                />
              </Stack>

              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Status*
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="status"
                  value={Status.value}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlechange}
                  options={status.map((value, index) => {
                    return {
                      value: index,
                      label: value,
                    };
                  })}
                  error={false}
                  // success={true}
                  isClearable
                />
              </Stack>

              <Stack alignItems="center" lineHeight={1}>
                {/* <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={handleclick}
                            
                        >
                            Source Profile
                        </MaterialButton> */}
              </Stack>
            </Stack>
            {/* <br></br> */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Employee type*
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="Employe type"
                  value={emptype.value}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlechange}
                  options={Departmentnames.depatmentdate.map((value) => {
                    return {
                      value: value.id,
                      label: value.departmentName,
                    };
                  })}
                  error={false}
                  // success={true}
                  isClearable
                />
              </Stack>

              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Role*
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="role"
                  value={role.value}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlechange}
                  options={Departmentnames.depatmentdate.map((value) => {
                    return {
                      value: value.id,
                      label: value.departmentName,
                    };
                  })}
                  error={false}
                  // success={true}
                  isClearable
                />
              </Stack>

              <Stack>
                <MaterialBox lineHeight={1} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    No of Positions*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name={"position"}
                  value={textfeilds.position}
                  type={number}
                  onChange={(e) => handlefield(e, "position")}
                />
              </Stack>
              <Stack>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    lineHeight={3}
                  >
                    Requested Date*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name={"position"}
                  value={textfeilds.date}
                  type={"date"}
                  onChange={(e) => handlefield(e, "date")}
                />
              </Stack>

              <Stack alignItems="center" lineHeight={1}>
                {/* <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={handleclick}
                            
                        >
                            Source Profile
                        </MaterialButton> */}
              </Stack>
            </Stack>
          </>
        }
      />
      <MaterialDataGrid
        // customHeight={550}
        rows={""}
        columns={SalaryStructureListTable.columns}
        checkboxSelection={false}
        isSelectable={false}
        onRowClick={""}
        loading={""}
        localeText={{
          noRowsLabel: (
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={1}
            >
              <MaterialTypography
                variant="body2"
                fontWeight="medium"
                color="text"
              >
                No employee salary found
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                You have not yet add any employee salary details. Click on the
                "Configure Salary" button to start adding employee salary
                details.
              </MaterialTypography>
            </Stack>
          ),
        }}
      />
    </Card>
   </DashboardLayout>
  );
};
export default RecruitOnboardReport;
